import SalespointsMap from '@/components/googleMap/SalespointsMap'
import GoogleMapsService from '@/services/GoogleMapsService'

/**
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * 
 * @todo - as described in SalespointsMap.js this part of code will be rewrited soon.
 * There's reported task for this - IG-1300
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 */

export function init () {
  const root = document.querySelector('.salesPoints__mapWrapper')
  if (!root) return false

  return new GoogleMapsService().init()
    .then(() => SalespointsMap.loadMap())
}


// WEBPACK FOOTER //
// ./src/modules/salespointsMap.js